export enum KanbanColumnsCount {
  FREE = 18,
  PAID = 18,
}
